import { render, staticRenderFns } from "./MergeError.vue?vue&type=template&id=cf5c7e40"
import script from "./MergeError.vue?vue&type=script&lang=js"
export * from "./MergeError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports